import classNames from "classnames";
import { Button, ButtonVariant, Text } from "@merge-api/merge-javascript-shared";
import { ExternalLink } from "lucide-react";

interface SectionProps {
  title: string;
  linkName?: string;
  onClick?: () => void;
  content: React.ReactNode | string;
  overviewBodyTextClassName?: string;
}

const OverviewSection = (props: SectionProps) => {
  const { title, linkName, onClick, content, overviewBodyTextClassName } = props;

  return (
    <div className="flex flex-column w-full">
      <div className="flex flex-row items-center w-full justify-between mb-1">
        <Text as="div" className="text-gray-40" variant="pre-title">
          {title}
        </Text>
        {linkName != undefined && (
          <Button
            variant={ButtonVariant.TextBlue}
            size="sm"
            onClick={onClick}
            rightIcon={<ExternalLink size={12} />}
          >
            {linkName}
          </Button>
        )}
      </div>
      <Text as="div" variant="h6" className={classNames(overviewBodyTextClassName)}>
        {content}
      </Text>
    </div>
  );
};

export default OverviewSection;
